import { useQuery } from '@tanstack/react-query'
import { useUser } from '~/features/auth/api/useUser'
import { useStakeWindow } from '../hooks/useStakeWindow'

const API_URL = '/api/nft/staking/points'

export const useUserPoints = () => {
    const { data: user } = useUser()
    const { query: window } = useStakeWindow()

    const query = useQuery<UserPoints>({
        queryKey: [API_URL],
        queryFn: async () => {
            const res = await fetch(`${API_URL}?${window}`)
            const data = await res.json()
            return data
        },
        retry: false,
        enabled: !!user,
    })

    return query
}
